import { lazy } from 'react';
const PaymentReversalApproval = lazy(() => import('./PaymentReversalApproval'));

const paymentReversalApprovalRoutes = [
  {
    path: '/payment-reversal-approval',
    component: PaymentReversalApproval
  }
];

export default paymentReversalApprovalRoutes;
